import React, { useEffect, useState } from "react";
import Banner from "../Banner/Banner";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { onUserAcademyDetails } from "../../redux/homeAction";
import { useParams } from "react-router-dom";
import Loader from "../loader/Loader";
import { Helmet } from "react-helmet";

const AcademyBlog = () => {
  const dispatch = useDispatch();
  const { slug } = useParams();
  const article = useSelector((state) => state.home.getUserAcademyDetails?.result);
  const [loader, setLoader] = useState(false);
  const classSend = "position-relative";

  useEffect(() => {
    setLoader(true);
    dispatch(onUserAcademyDetails(slug, setLoader));
  }, [slug]);

  const wordsArray = article?.title?.split(" ");
  const lastWord = wordsArray && wordsArray[wordsArray?.length - 1];
  const allWords = wordsArray && wordsArray.filter((word) => word !== lastWord);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <>
      <Helmet>
        <title>{article?.meta_title || article?.title}</title>
        <meta name="description" content={article?.meta_description} />
        <meta name="keywords" content={article?.meta_keywords} />
        <meta property="og:title" content={article?.meta_title || article?.title} />
        <meta property="og:description" content={article?.meta_description} />
        <meta property="og:image" content={article?.image} />
        <meta property="og:type" content="article" />
      </Helmet>
      <Navbar classSend={classSend} />
      <section className="awards_section">
        <div className="container">
          {loader ? (
            <div className="text-center">
              <Loader />
            </div>
          ) : (
            <>
              {article?.image && (
                <div className="article-image mb-4" style={{ maxWidth: '800px', margin: '0 auto' }}>
                  <img 
                    src={article.image} 
                    alt={article.title} 
                    className="img-fluid" 
                    style={{ 
                      width: '100%', 
                      height: 'auto', 
                      maxHeight: '400px',
                      objectFit: 'contain',
                      borderRadius: '8px'
                    }} 
                  />
                </div>
              )}
              <h1 className="h1_60">
                {allWords?.join(" ")}{" "}
                <span className="color_yellow">{lastWord}</span>
              </h1>
              <div className="article-container" style={{ color: '#f8f9fa', marginBottom: '20px' }}>
                <div className="article-meta text-muted mb-4">
                  <p>Publicado: {article?.created_at && formatDate(article.created_at)}</p>
                  {article?.updated_at !== article?.created_at && (
                    <p>Actualizado: {formatDate(article.updated_at)}</p>
                  )}
                </div>
                <div 
                  className="blog_content" 
                  dangerouslySetInnerHTML={{ __html: article?.content }}
                  style={{
                    maxWidth: '800px',
                    margin: '0 auto',
                    fontSize: '16px',
                    lineHeight: '1.6',
                    color: '#333333'
                  }}
                />
              </div>
            </>
          )}
          <Banner />
        </div>
      </section>
      <Footer />
    </>
  );
};

export default AcademyBlog;
